import { allMapsImageData, allPieces } from "@/utils/data"
import classNames from "classnames"
// import goToJailImage from "@/images/boards/default/go-to-jail.png"
// import inJailImage from "@/images/boards/default/in-jail.png"
import { useAppSelector } from "@/store/hooks"
import { getUserCreds } from "@/utils/utils"
import { render } from "react-dom"
import { mapDesigns } from "@mono/mapDesigns"
import Piece from "@/Components/Piece"
import Pieces from "@/Components/Pieces"
import jailOverlayImage from "@/images/jail-overlay.svg"
import { useCallback, useEffect, useMemo, useRef } from "react"
import gsap from "gsap"
import { time } from "console"
import jailDropAudioFile from "@/audio/jail-drop.mp3"
import { getPlayerOrderFromPlayerId, isCellInBetweenCells, runGoToJailAnimation } from "@/utils/animationHelpers"
import { getOwnerOfProperty } from "@/utils/gameHelpers"
import { getTradeCardSelectionType } from "@/utils/tradeHelpers"
import HouseItemOriginal from "../Game/HouseItemOriginal"

interface MiniBoardCellProps {
  cell: ICell
  game: IGame
  map: IMapDesign
}

const HistoryBoardCell: React.FC<MiniBoardCellProps> = ({ cell, map, game }) => {
  const myGroup = map.groups.find((group) => group.id === cell.propertyDetails?.groupId)
  const myGame = useAppSelector((state) => state.global.myGame)
  const myRowSize = Math.floor(map.cells.length / 4)
  const myRow = Math.floor(cell.order / myRowSize)
  const rowClass = "row" + myRow
  const activePlayer = myGame?.situation?.players.find((player) => player.id === myGame.situation?.turn)
  const higherZIndex = activePlayer?.position === cell.order
  const mapImageData = allMapsImageData.find((map) => map.mapId === myGame?.settings.mapId)
  const cellImageData = mapImageData?.cellImages.find((cellImageData) => cellImageData.order === cell.order)
  useEffect(() => {}, [])
  const owner = game.situation?.players.find((player) => player.properties.includes(cell.order))
  const ownerImage = allPieces.find((piece) => piece.id === owner?.pieceId)
  const brightnessClass = "!brightness-50"
  const playersInThisCell = game.situation?.players?.filter((player) => player.position === cell.order) as IPlayer[]
  const myHousesCount = game?.situation?.housesData.find((item) => item.propertyOrder === cell.order)?.houses || 0
  const renderHouses = useCallback(() => {
    return (
      <>
        {myHousesCount === 5 ? (
          <HouseItemOriginal index={4} propertyOrder={cell.order}></HouseItemOriginal>
        ) : (
          Array(myHousesCount)
            .fill(0)
            .map((_, i) => <HouseItemOriginal index={i} propertyOrder={cell.order}></HouseItemOriginal>)
        )}
      </>
    )
  }, [cell.order, myHousesCount])
  const renderPieces = () => {
    return (
      <div
        className={classNames(
          "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 grid  z-10  w-full items-center justify-center",
          {
            "grid-rows-1 grid-cols-1": playersInThisCell?.length === 1,
            "grid-rows-1 grid-cols-2": playersInThisCell?.length === 2,
            "grid-rows-2 grid-cols-2": playersInThisCell!.length > 2,
          }
        )}
      >
        {playersInThisCell?.map((player) => {
          const myPieceId = player?.pieceId
          const myPeice = allPieces.find((piece) => piece.id === myPieceId)
          return (
            //@ts-ignore
            <img
              key={myPieceId}
              id={`piece-${player.order}`}
              className={classNames("piece justify-self-center  ", {
                jailed: player.inJail,
                // "w-6 h-6": isMobile(),
                // "brightness-200": true,
              })}
              src={myPeice!.imgSrc || ""}
              data-testid={`game.piece-${myPieceId}`}
            ></img>
          )
        })}
      </div>
    )
  }
  if (cell.type === "property") {
    return (
      <div
        id={`cell-${cell.order}`}
        data-testid={`game.cell-${cell.order}`}
        className={classNames(
          "flex flex-col w-full h-full bg-primary relative cell border border-black bg-center bg-no-repeat ",
          {
            horizontal: cell.direction === "horizontal",
            vertical: cell.direction === "vertical",
            "z-10": higherZIndex,
            [rowClass]: true,
          }
        )}
        style={{
          backgroundImage: `url(${cellImageData?.background})`,
          gridArea: "c" + cell.order,
          backgroundSize: "contain",
        }}
      >
        {/* <Pieces cell={cell}></Pieces> */}
        {myGroup?.withStrip && (
          <>
            <div className="cell-color " style={{ background: myGroup.color }}>
              {renderHouses()}
            </div>
          </>
        )}
        {renderPieces()}
        {cell.propertyDetails && (
          <div
            className={classNames("flex flex-col relative  gap-2 items-center justify-between  h-full w-full  ", {
              "px-2": cell.direction === "vertical",
              "py-2": cell.direction === "horizontal",
            })}
          >
            <div className="text-[8px] cell-title font-poppins text-center font-medium ">
              {cell.propertyDetails && cell.propertyDetails.name}
            </div>
            {ownerImage?.placeholder && (
              <img
                src={ownerImage?.placeholder}
                className={classNames("absolute top-1/2 left-1/2  -translate-x-1/2  opacity-[0.5] grayscale-[0]  ", {
                  "w-[3rem] h-auto -translate-y-[40%]": cell.direction === "horizontal",
                  "h-[3rem] w-auto rotate-90 -translate-y-[50%]": cell.direction === "vertical",
                })}
              ></img>
            )}
            {cellImageData?.image && (
              <div className="relative flex-grow flex justify-center items-center h-3/4 w-3/4">
                <img
                  className={classNames("object-contain absolute h-full w-auto")}
                  src={cellImageData?.image}
                  alt="Tile"
                />
              </div>
            )}
            <div
              className={classNames("text-[9px] font-poppins text-center", {
                "mt-0": cellImageData?.image && cell.direction === "horizontal",
              })}
            >
              M{cell.propertyDetails?.price}
            </div>
          </div>
        )}
      </div>
    )
  }
  if (cell.type === "action") {
    return (
      <div
        id={`cell-${cell.order}`}
        style={{
          gridArea: "c" + cell.order,
        }}
        data-testid={`game.cell-${cell.order}`}
        className={classNames(
          "flex flex-col gap-2   w-full h-full bg-primary cell border border-black relative bg-center bg-no-repeat",
          {
            "px-2": cell.direction === "vertical",
            "py-2": cell.direction === "horizontal",
            horizontal: cell.direction === "horizontal",
            vertical: cell.direction === "vertical",
            "z-10": higherZIndex,
            [rowClass]: true,
          }
        )}
      >
        {/* <Pieces cell={cell}></Pieces> */}
        {renderPieces()}
        <div className="text-[8px] cell-title font-poppins text-center font-medium  uppercase"></div>
        {cellImageData?.image && (
          <div className="relative flex-grow flex justify-center items-center h-full w-full">
            <img
              className={classNames("object-contain absolute h-full w-auto")}
              src={cellImageData?.image}
              alt="Tile"
            />
          </div>
        )}
      </div>
    )
  }
  if (cell.taxDetails) {
    return (
      <div
        id={`cell-${cell.order}`}
        style={{
          gridArea: "c" + cell.order,
        }}
        data-testid={`game.cell-${cell.order}`}
        className={classNames(
          "flex flex-col justify-between items-center  w-full h-full bg-primary cell border border-black relative bg-center bg-no-repeat ",
          {
            "py-2": cell.direction == "horizontal",
            "px-2": cell.direction === "vertical",
            horizontal: cell.direction === "horizontal",
            vertical: cell.direction === "vertical",
            "z-10": higherZIndex,
            [rowClass]: true,
          }
        )}
      >
        {/* <Pieces cell={cell}></Pieces> */}
        {renderPieces()}
        <div className="text-xs cell-title font-poppins text-center font-medium  uppercase cell-title-upper">
          {cell.taxDetails.name}
        </div>

        <div className="relative flex-grow flex justify-center items-center h-full w-full">
          <img
            className={classNames("object-contain absolute h-full w-auto")}
            style={{ maxHeight: cellImageData?.maxHeight + "px" }}
            src={cellImageData?.image}
            alt="Tile"
          />
        </div>
        <div className="text-[8px] cell-title font-poppins text-center font-medium uppercase tax-price">
          PAY M{cell.taxDetails.price}
        </div>
      </div>
    )
  }
  if (cell.type === "go-to-jail") {
    return (
      <div
        id={`cell-${cell.order}`}
        style={{
          gridArea: "c" + cell.order,
        }}
        data-testid={`game.cell-${cell.order}`}
        className={classNames(
          "flex flex-col  w-full h-full bg-primary cell border border-black relative bg-center bg-no-repeat",

          {
            "px-2": cell.direction === "vertical",
            "py-2": cell.direction === "horizontal",
            horizontal: cell.direction === "horizontal",
            vertical: cell.direction === "vertical",
            "z-10": higherZIndex,
            [rowClass]: true,
          }
        )}
      >
        {/* <Pieces cell={cell}></Pieces> */}
        {renderPieces()}
        <div>
          {/* <img
            className={classNames(
              "object-contain absolute top-1/2 left-1/2 origin-center rotate-90 -translate-x-1/2 - -translate-y-1/2",
              {
                "w-auto h-full min-h-0": cell.direction === "horizontal",
                "w-auto h-full min-w-0": cell.direction === "vertical",
              }
            )}
            src={goToJailImage}
            alt="Tile"
          /> */}
        </div>
      </div>
    )
  }
  if (cell.type === "jail") {
    return (
      <div
        id={`cell-${cell.order}`}
        style={{
          gridArea: "c" + cell.order,
        }}
        data-testid={`game.cell-${cell.order}`}
        className={classNames(
          "flex flex-col  w-full h-full bg-primary cell border border-black relative bg-center bg-no-repeat",

          {
            "px-2": cell.direction === "vertical",
            "py-2": cell.direction === "horizontal",
            horizontal: cell.direction === "horizontal",
            vertical: cell.direction === "vertical",
            "z-10": higherZIndex,
            [rowClass]: true,
          }
        )}
      >
        {/* <Pieces cell={cell}></Pieces> */}
        {renderPieces()}
        <div className="absolute right-0 h-3/4 w-3/4">
          {/* <img
            id="jail-area"
            className={classNames(
              "object-contain absolute top-0 right-0 origin-center rotate-90  h-full w-full border-b border-r  border-black"
            )}
            src={inJailImage}
            alt="Tile"
          /> */}
          <img src={jailOverlayImage} className="h-full w-full z-[101] absolute opacity-0" alt="" />
        </div>

        <div className="absolute hidden text-[8px] font-poppins left-0 font-medium top-4  items-center justify-center w-1/4">
          JUST
        </div>
        <div
          className="absolute text-[8px] hidden font-poppins bottom-0 font-medium left-0  items-center justify-center w-full h-1/4 "
          style={{ writingMode: "initial" }}
        >
          VISITING
        </div>
      </div>
    )
  }

  return (
    <div
      id={`cell-${cell.order}`}
      className={classNames("flex flex-col w-full h-full bg-primary cell  relative bg-center bg-no-repeat ", {
        "z-10": higherZIndex,
      })}
      data-testid={`game.cell-${cell.order}`}
      style={{
        backgroundImage: `url(${cellImageData?.background})`,
        backgroundSize: "contain",
        gridArea: "c" + cell.order,
        [rowClass]: true,
      }}
    >
      {/* <Pieces cell={cell}></Pieces> */}
      {renderPieces()}
      <div
        className={classNames("flex flex-col  gap-2 items-center justify-between  h-full w-full  ", {
          "px-2": cell.direction === "vertical",
          "py-2": cell.direction === "horizontal",
        })}
      >
        {cellImageData?.image && (
          <div className="relative flex-grow flex justify-center items-center h-full w-full">
            <img
              className={classNames("object-contain absolute h-full w-auto")}
              src={cellImageData?.image}
              alt="Tile"
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default HistoryBoardCell
